import { render, staticRenderFns } from "./Matcher.vue?vue&type=template&id=278dc716&scoped=true&"
import script from "./Matcher.vue?vue&type=script&lang=js&"
export * from "./Matcher.vue?vue&type=script&lang=js&"
import style0 from "./Matcher.vue?vue&type=style&index=0&id=278dc716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278dc716",
  null
  
)

export default component.exports